import { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Select, Spin, notification } from "antd";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "../../../utils/axios";
import { AiOutlineEye, AiFillEye } from "react-icons/ai";
import { errorBlock } from "../../../controllers/errorBlock";

const AddAppUser = ({ open, setopen, tabdefault }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const siteDetails = useSelector((state) => state.projectSite);
  const [tabstate, settabstate] = useState(tabdefault ? 2 : 1);
  const [loading, setLoading] = useState(false);
  const [userloading, setuserloading] = useState(false);
  const [CustomerType, setCustomerType] = useState([]);
  const [selectedcst, setselectedcst] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        let res = await axios.post("/settings/getdropdown", {
          comboname: "customertype",
        });

        setCustomerType(!res.data?.list ? [] : res.data?.list.split(", "));
      } catch (err) {
        toast.error(err.message);
      }
    })();
  }, []);

  const handleUserName = async () => {
    try {
      const name = form.getFieldValue("username");
      if (!name) return toast.error("Please enter a username");
      setuserloading(true);

      let res = await axios.post(
        "/auth/utility/customeraccount/isusernameused",
        { username: name }
      );
      if (res.data.message) {
        toast.error("The username you entered has been used.");
      } else {
        settabstate(2);
      }
    } catch (err) {
      toast.error(err.message);
      setopen(false);
    } finally {
      setuserloading(false);
    }
  };

  const onSubmit = async (values) => {
    try {
      if (!selectedcst) return toast.error("Customer type is required.");
      setLoading(true);

      values.password = "12345";
      let res = await axios.post(
        "/auth/utility/customeraccount/createaccount",
        {
          ...values,
          customertype: selectedcst,
        }
      );

      if (res.data.response == "userexists") {
        notification.error({
          message: "Failure",
          description: "Customer with username already exists",
        });
        setLoading(false);
        return;
      }

      if (res.data.response == "failure") {
        notification.error({
          message: "Failure",
          description: "Failed to create customer",
        });
        setLoading(false);
        return;
      }

      if (res.data.response == "error") {
        notification.error({
          message: "Failure",
          description: res.data.message || "Failed to create customer",
        });
        setLoading(false);
        return;
      }

      notification.success({
        message: "Success",
        description: "Customer registered successfully!",
      });
      setopen(false);
      navigate("/manage-meter?tab=2");
    } catch (err) {
      errorBlock(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onCancel={() => setopen(false)} footer={null} centered>
      <h3 className="text-lg font-semibold">Register Customer</h3>
      <p className="text-gray-700">
        Fill the fields to register a customer in{" "}
        <strong>{siteDetails?.sitename}</strong>
      </p>

      <Form size="large" form={form} layout="vertical" onFinish={onSubmit}>
        {tabstate === 1 ? (
          <>
            <Form.Item
              label="Username / Email / Phone / Lastname / Firstname"
              name="username"
              rules={[{ required: true, message: "Username is required" }]}
            >
              <Input placeholder="Enter username" />
            </Form.Item>

            <Button
              type="primary"
              block
              className="!border-none !bg-black"
              onClick={handleUserName}
              loading={userloading}
            >
              Continue
            </Button>
          </>
        ) : (
          <>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                label="First Name"
                name="firstname"
                rules={[{ required: true, message: "First name is required" }]}
              >
                <Input placeholder="Enter first name" />
              </Form.Item>

              <Form.Item
                label="Last Name"
                name="lastname"
                rules={[{ required: true, message: "Last name is required" }]}
              >
                <Input placeholder="Enter last name" />
              </Form.Item>
            </div>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Email is required" }]}
            >
              <Input placeholder="Enter email" />
            </Form.Item>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                label="Username"
                name="username"
                rules={[{ required: true, message: "Username is required" }]}
              >
                <Input placeholder="Enter username" />
              </Form.Item>

              <Form.Item
                label="Phone Number"
                name="phone"
                rules={[
                  { required: true, message: "Phone number is required" },
                ]}
              >
                <Input placeholder="Enter phone number" />
              </Form.Item>
            </div>
            <div className="grid grid-cols-1 gap-4">
              {/* <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: "Password is required" }]}
              >
                <Input.Password
                  placeholder="Enter password"
                  iconRender={(visible) =>
                    visible ? <AiFillEye /> : <AiOutlineEye />
                  }
                />
              </Form.Item> */}
              <Form.Item
                label="Customer Type"
                rules={[
                  { required: true, message: "Customer type is required" },
                ]}
              >
                <Select
                  showAction
                  showSearch
                  placeholder="Select a customer type"
                  options={CustomerType.map((item) => ({
                    value: item.trim(),
                    label: item.trim(),
                  }))}
                  onChange={setselectedcst}
                />
              </Form.Item>
            </div>
            <Form.Item
              label="Address"
              name="address"
              rules={[{ required: true, message: "Address is required" }]}
            >
              <Input.TextArea placeholder="Enter address" />
            </Form.Item>

            <div className="flex justify-between">
              <Button onClick={() => settabstate(1)}>Back</Button>
              <Button
                type="primary"
                className="!border-none !bg-black"
                htmlType="submit"
                loading={loading}
              >
                Add Customer
              </Button>
            </div>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default AddAppUser;
